import React from 'react'

export default function CardAppStore() {
    return (
        <div className="card card-custom card-stretch  gutter-b">
            <div className="card-header align-items-center border-0">
                <h3 className="card-title align-items-start">
                    <span className="font-weight-bolder text-dark">
                        Download your SGU Mobile
                    </span>
                </h3>
            </div>
            <div className="card-body pt-0">
                <a href="https://play.google.com/store/apps/details?id=id.ac.sgu.mobile&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                    <img
                        alt="Get it on Google Play"
                        className="w-100"
                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                    />
                </a>

                <a href="https://apps.apple.com/id/app/sgu-mobile-app/id6448629664?itsct=apps_box_badge&amp;itscg=30200" >
                    <img
                        alt="Download on App Store"
                        className="w-100 p-3"
                        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1683158400" />
                </a>
            </div>
        </div>
    )
}
